import { ApiPropertyOptional } from '@nestjs/swagger'
import {
  IsOptional,
  IsString,
  IsUUID,
  IsArray,
  ValidateNested,
  IsNumber,
} from 'class-validator'
import { Type } from 'class-transformer'
import { TeachingDto, LessonDto, ResourceLightDto } from '@sphere/school/domain'
import { ConceptDto } from '@sphere/curriculum/domain'

/**
 * Lightweight DTOs for AI context (matches Python models)
 */
export class SubjectContextDto {
  @IsOptional()
  @IsUUID()
  id?: string

  @IsOptional()
  @IsString()
  name?: string
}

export class LevelContextDto {
  @IsOptional()
  @IsUUID()
  id?: string

  @IsOptional()
  @IsString()
  name?: string
}

export class ChapterContextDto {
  @IsOptional()
  @IsUUID()
  id?: string

  @ApiPropertyOptional({ description: 'Titre du chapitre', type: 'string' })
  @IsOptional()
  @IsString()
  title?: string

  @ApiPropertyOptional({ description: 'Description du chapitre', type: 'string' })
  @IsOptional()
  @IsString()
  description?: string
}
/**
 * DTO pour le contexte d'activité utilisé lors de la génération avec l'IA
 */
export class ActivityContextDto {
  @ApiPropertyOptional({ description: 'Leçons', type: () => [LessonDto] })
  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => LessonDto)
  lessons?: LessonDto[]

  @ApiPropertyOptional({ description: "Titre de l'activité", type: 'string' })
  @IsOptional()
  @IsString()
  title?: string

  @ApiPropertyOptional({ description: "Description de l'activité", type: 'string' })
  @IsOptional()
  @IsString()
  description?: string

  @ApiPropertyOptional({
    description: 'Ressources liées',
    type: () => [ResourceLightDto],
  })
  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => ResourceLightDto)
  resources?: ResourceLightDto[]

  @ApiPropertyOptional({ description: 'Concepts liés', type: () => [ConceptDto] })
  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => ConceptDto)
  concepts?: ConceptDto[]

  @ApiPropertyOptional({ description: 'Temps moyen de complétion' })
  @IsOptional()
  @IsNumber()
  averageCompletionTime?: number

  @ApiPropertyOptional({ description: 'Liste des enseignements lié', type: () => [TeachingDto] })
  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => TeachingDto)
  teachings?: TeachingDto[]

  @ApiPropertyOptional({ description: 'Matière associée' })
  @IsOptional()
  @ValidateNested()
  @Type(() => SubjectContextDto)
  subject?: SubjectContextDto

  @ApiPropertyOptional({ description: 'Niveau associé' })
  @IsOptional()
  @ValidateNested()
  @Type(() => LevelContextDto)
  level?: LevelContextDto

  @ApiPropertyOptional({ description: 'Chapitre associé' })
  @IsOptional()
  @ValidateNested()
  @Type(() => ChapterContextDto)
  chapter?: ChapterContextDto
}
